import { __assign, __values } from "tslib";
import React, { memo, useMemo, useCallback } from 'react';
import { FieldMatcherID, fieldMatchers, getFieldDisplayName, } from '@grafana/data';
import { MultiSelect } from '../Select/Select';
import { Input } from '../Input/Input';
export var FieldNamesMatcherEditor = memo(function (props) {
    var _a;
    var data = props.data, options = props.options, onChangeFromProps = props.onChange;
    var readOnly = options.readOnly, prefix = options.prefix;
    var names = useFieldDisplayNames(data);
    var selectOptions = useSelectOptions(names);
    var onChange = useCallback(function (selections) {
        if (!Array.isArray(selections)) {
            return;
        }
        return onChangeFromProps(__assign(__assign({}, options), { names: selections.reduce(function (all, current) {
                if (!(current === null || current === void 0 ? void 0 : current.value) || !names.has(current.value)) {
                    return all;
                }
                all.push(current.value);
                return all;
            }, []) }));
    }, [names, onChangeFromProps, options]);
    if (readOnly) {
        var displayNames = ((_a = options.names) !== null && _a !== void 0 ? _a : []).join(', ');
        return React.createElement(Input, { value: displayNames, readOnly: true, disabled: true, prefix: prefix });
    }
    return React.createElement(MultiSelect, { value: options.names, options: selectOptions, onChange: onChange });
});
FieldNamesMatcherEditor.displayName = 'FieldNameMatcherEditor';
export var fieldNamesMatcherItem = {
    id: FieldMatcherID.byNames,
    component: FieldNamesMatcherEditor,
    matcher: fieldMatchers.get(FieldMatcherID.byNames),
    name: 'Fields with name',
    description: 'Set properties for a specific field',
    optionsToLabel: function (options) { var _a; return ((_a = options.names) !== null && _a !== void 0 ? _a : []).join(', '); },
    excludeFromPicker: true,
};
var useFieldDisplayNames = function (data) {
    return useMemo(function () {
        var e_1, _a, e_2, _b;
        var names = new Set();
        try {
            for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                var frame = data_1_1.value;
                try {
                    for (var _c = (e_2 = void 0, __values(frame.fields)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var field = _d.value;
                        names.add(getFieldDisplayName(field, frame, data));
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return names;
    }, [data]);
};
var useSelectOptions = function (displayNames) {
    return useMemo(function () {
        return Array.from(displayNames).map(function (n) { return ({
            value: n,
            label: n,
        }); });
    }, [displayNames]);
};
//# sourceMappingURL=FieldNamesMatcherEditor.js.map